import { Link } from "react-router-dom";

const columns = [
  {
    title: "影视分类",
    links: [
      { label: "最新电影", to: "/category/movie" },
      { label: "热播剧集", to: "/category/tv" },
      { label: "全部作品", to: "/category/movie" },
      { label: "站内搜索", to: "/search?q=悬疑" },
    ],
  },
  {
    title: "影评专题",
    links: [
      { label: "静水深流", to: "/special/silent-current" },
      { label: "烟火人间", to: "/special/ordinary-lives" },
      { label: "被记忆修改的人", to: "/special/memory-machine" },
      { label: "关于我们", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="container-portal py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2 md:pr-10">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-[12px] font-black leading-none text-background-50">
                人兽
              </span>
              <span className="text-[17px] font-bold text-background-50">人兽影视网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-200/80">
              专注电影与电视剧的内容门户，提供最新影视资讯、完整剧情介绍、演员资料与影评分析。我们不做播放，只把故事讲清楚。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-background-200/80">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                contact@renshou-film.com
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" />
                北京 · 朝阳
              </span>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="label-caps text-[11px] text-background-300/70">{column.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/85 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-50/15 pt-6 text-xs text-background-300/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 人兽影视网 Renshou Film. 保留所有权利。</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>友情链接</span>
            <span className="text-background-400/60">光影资料馆</span>
            <span className="text-background-400/60">剧集观察站</span>
            <span className="text-background-400/60">影展手册</span>
          </div>
        </div>
        <p className="mt-3 text-[11px] leading-5 text-background-400/60">
          本站为影视内容展示与演示站点，所有影视条目均为示例数据，不提供播放、下载、票务或任何付费服务。
        </p>
      </div>
    </footer>
  );
}